import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getPatientInformationState } from '../selectors'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { IPcr } from '../../pcr/store/pcr.types'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { IPatientInformationState } from '../store/patientInformation.types'
import { PatientInformationConstants } from '../store/patientInformation.constants'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* savePatientInformation() {
  const patientInformation: IPatientInformationState = yield select(getPatientInformationState)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  try {
    if (pcrID) {
      const pcrDocsService = new PcrDocsService(serviceId)
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      const pcrDocUpdated: IPcr = {
        ...pcrDoc,
        patient: {
          ...pcrDoc.patient,
          patientInformation: {
            ...patientInformation,
          },
        },
      }
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    }
  } catch (e) {
    yield put(throwPcrException(`savePatientInformation() error: ${e}`))
  }
}

export function* savePatientInformationSaga() {
  yield takeLatest(
    [PatientInformationConstants.SET_NEW_PATIENT, PatientInformationConstants.SET_SEARCH_IMPORT],
    performWithMutexHOG,
    savePatientInformation
  )
}
